<div class="container">
  <form class="my-3" [formGroup]="form">
    <div class="form-row">
      <div class="col">
        <label>비율 {{ form.value.ratio }}%</label>
        <input
          type="range"
          class="custom-range"
          min="0"
          max="200"
          step="1"
          formControlName="ratio"
        />
      </div>
      <div class="col">
        <label>퀄리티 {{ form.value.quality }}%</label>
        <input
          type="range"
          class="custom-range"
          min="0"
          max="200"
          step="1"
          formControlName="quality"
        />
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <label>이미지 파일</label>
        <div class="custom-file">
          <input
            type="file"
            class="custom-file-input"
            (change)="selectFile($event)"
          />
          <label class="custom-file-label" accept=".jpg,.png,.jpeg"
            >Choose file</label
          >
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="img" class="card" style="width: 18rem;">
    <img [src]="img" class="card-img-top" alt="원본" />
    <div class="card-body">
      <h5 class="card-title">원본 이미지</h5>
      <p class="card-text">File Size : {{ imgSize | number: "1.2-2" }}MB</p>
    </div>
  </div>

  <div *ngIf="convertImg" class="my-3 p-3 border shadow">
    <p>File Size : {{ convertImgSize | number: "1.2-2" }}MB</p>
    <img [src]="convertImg" alt="압축" />
  </div>
</div>
